import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { projectFeedFailingProjectsBackend } from './project-feed-failing-projects.backend';
import { projectFeedFailingProjectsReducer } from './project-feed-failing-projects.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'projectFeedFailingProjects',
      projectFeedFailingProjectsReducer,
    ),
    BackendModule.forFeature(
      'projectFeedFailingProjects',
      projectFeedFailingProjectsBackend,
    ),
  ],
})
export class DatastoreProjectFeedFailingProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed-failing-projects/project-feed-failing-projects.module.ts